import PersonalDetails from "./personalDetails"
export default PersonalDetails;